module.exports = __webpack_public_path__ + "static/media/ipb_logo.52b596c4.svg";